import React from "react";

import Styles from "./Data.styles";
import { DataProps as Props } from "./Data.types";
import Footer from "components/global/Footer/Footer";
import GoBack from "components/global/GoBack/GoBack";
import Navbar from "components/global/Navbar/Navbar";
import ProfileNavigation from "components/global/ProfileNavigation/ProfileNavigation";
import useI18n from "hooks/useI18n";

const Data: React.FC<Props> = props => {
  const t = useI18n();

  return (
    <Styles className="Data">
      <header className="Data__header">
        <Navbar showBrand />
      </header>
      <main className="Data__main">
        <ProfileNavigation className="Data__profile-navigation" />
        <section className="Data__content">
          <GoBack className="Data__go-back" title="Atrás" />
          <div className="Data__container">
            <h1 className="Data__title">{t.terms.data}</h1>
            <p className="Data__paragraph">
              Sobre el tratamiento de datos personales:
            </p>
            <p className="Data__paragraph">
              Los datos personales que el usuario proporcione y/o registre serán
              incluidos en una base de datos, (en adelante DATOS o INFORMACIÓN)
              y serán utilizados con el propósito de:
            </p>
            <ul>
              <li className="Data__list-items">
                Facilitar la correcta ejecución de las reservas, compras y
                prestación de servicios contratados.
              </li>
              <li className="Data__list-items">
                Cumplir con las obligaciones contraídas con los distintos
                usuarios.
              </li>
              <li className="Data__list-items">
                Informar sobre promociones, ofertas, novedades, productos y
                servicios, alianzas, concursos, contenidos actuales y futuros
                relacionados con los eventos, actividades de promoción y otras
                finalidades comerciales directa o indirectamente relacionados
                con nuestra actividad.
              </li>
              <li className="Data__list-items">
                Informar sobre nuevos productos o servicios que estén
                relacionados con el o los contratado(s) o adquirido(s) o cambios
                en los mismos.
              </li>
              <li className="Data__list-items">
                Evaluar la calidad de servicio.
              </li>
              <li className="Data__list-items">
                Realizar estudios internos sobre hábitos de consumo.
              </li>
              <li className="Data__list-items">
                Efectuar estudios estadísticos que permitan diseñar mejoras en
                los productos y/o en los servicios prestados.
              </li>
              <li className="Data__list-items">
                Establecer perfiles determinados con fines publicitarios y de
                marketing en general.
              </li>
              <li className="Data__list-items">
                Gestionar tareas básicas de administración.
              </li>
            </ul>
            <p className="Data__paragraph">
              Para efectos de esta autorización se entiende por “tratamiento” a
              cualquier operación o conjunto de operaciones realizadas con los
              datos del usuario, ya sea por procedimientos técnicos de carácter
              automatizado, parcialmente automatizado o no automatizado, tales
              como, pero sin limitarse a: la recogida, recopilación, obtención,
              registro, organización, estructuración, evaluación, análisis,
              conservación, custodia, adaptación, modificación, eliminación,
              indexación, extracción, consulta, elaboración, utilización,
              procesamiento, consolidación, anonimización, seudonimización,
              aprovechamiento, rentabilización, distribución, cesión,
              comunicación, transferencia, o cualquier otra forma de
              habilitación de acceso, cotejo, interconexión, limitación,
              supresión, destrucción y, en general, cualquier uso de DATOS.
            </p>
            <p className="Data__paragraph">
              Desde el momento en que el usuario registre sus datos en el
              sistema de SUSHICORP S.A.S faculta y autoriza a éste para que los
              mismos sean consultados, compartidos, transferidos y/o comunicados
              a proveedores, subsidiarias, sociedades afiliadas, relacionadas
              y/o auxiliares, empresas encargadas del tratamiento de datos y/o
              sociedades con las que SUSHICORP S.A.S mantenga relación a nivel
              nacional o internacional. Para el efecto, SUSHICORP S.A.S adoptará
              las medidas técnicas y organizativas aplicables para cumplir con
              la confidencialidad y seguridad correspondientes.
            </p>
            <p className="Data__paragraph">
              El usuario para el ejercicio de los derechos de acceso,
              eliminación, rectificación, actualización, revisión, portabilidad
              y oposición, o cualquier otro derecho contenido en la Ley de
              Protección de Datos Personales, se podrá comunicar a la dirección
              de correo electrónico:{" "}
              <a href="mailto:servicioalcliente@sushicorp.ec">
                servicioalcliente@sushicorp.ec
              </a>
              ; o mediante comunicación escrita, entregada en las oficinas de
              SUSHICORP S.A.S ubicadas en el Centro de Negocios Paseo San
              Francisco Piso 3 Of. 6; o, presentar cualquier solicitud ante la
              Autoridad de Protección de Datos del Ecuador.
            </p>
            <p className="Data__paragraph">
              En función de lo antes detallado, el usuario autoriza a SUSHICORP
              S.A.S, a sus afiliadas o a empresas que sean contratadas por
              SUSHICORP S.A.S o las afiliadas de éstas últimas, para tratar los
              datos personales que proporcione y/o registre el usuario,
              actualmente o en el futuro. Asimismo, acepta en su totalidad los
              términos y condiciones contenidos en esta sección.
            </p>
            <p className="Data__paragraph">
              Asimismo, SUSHICORP S.A.S usa tecnología de geolocalización para
              automáticamente brindar información sobre el local más cercano al
              Usuario. En este sentido, el usuario acepta que SUSHICORP S.A.S, a
              través de sus plataformas digitales, emplee la tecnología de
              geolocalización.
            </p>
          </div>
        </section>
      </main>
      <footer className="Data__footer">
        <Footer />
      </footer>
    </Styles>
  );
};

Data.defaultProps = {};

export default Data;
